import {createApp} from 'vue'
const app = createApp(App);
import App from './App.vue'

import ECharts from 'vue-echarts' // 引入ECharts
import 'echarts' // 全局引入echarts

import Header from "@/components/Header";
import RightClick from "@/components/RightClick";
import 'element-plus/dist/index.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import VueRouter from './router/index';
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css';
import * as Elicons from "@element-plus/icons-vue";
import zhLocale from 'element-plus/es/locale/lang/zh-cn'
import echarts from './api/echarts'
import VueMarkdownEditor from '@kangc/v-md-editor';
import '@kangc/v-md-editor/lib/style/base-editor.css';
import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress.js';
import '@kangc/v-md-editor/lib/theme/style/vuepress.css';

import Prism from 'prismjs';

VueMarkdownEditor.use(vuepressTheme, {
    Prism,
});

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.config.globalProperties.$echarts = echarts;//vue3的挂载方式
app.component("Header", Header);
app.component("RightClick", RightClick);
import moment from "moment";
moment.locale('zh-cn');

for (const name in Elicons) {
    app.component(name, Elicons[name]);
}

// 在入口文件（如main.js）添加
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class extends _ResizeObserver {
    constructor(callback) {
        super(entries => {
            requestAnimationFrame(() => {
                callback(entries); // 延迟到下一帧执行
            });
        });
    }
};

app.component('ECharts',ECharts);
app.use(ElementPlus, {
    locale: zhLocale
});
app.use(VueMarkdownEditor);
app.use(VueRouter).mount('#app');



